import { IssueTypePriorityService as OvermapIssueTypePriorityService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class IssueTypePriorityService extends OvermapIssueTypePriorityService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
